import React from "react";
import { connect } from 'react-redux';
import Geocode from "react-geocode";
import SweetAlert from "react-bootstrap-sweetalert";


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from '@material-ui/core/CircularProgress';

import Add from "@material-ui/icons/AddBox";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

// style for this view
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { formatStatus, sanitize } from "../../../utils/helpers";
import { fetchProjectsRequest } from "../../../actions/project";
import { registerMeterRequest, fetchMetersReset } from "../../../actions/stockController";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_KEY);


const initialState = {
  meterType: '',
  meterPaymentType: '',
  condition: '',
  meterDialType: '',
  brand: '',
  tag: '',
  model: '',
  meterNumber: '',
  meterSerialNumber: '',
  meterReading: '',
  error: {},
  success: false,
  createdMeter: null,
};

class CreateMeter extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount() {
    this.props.dispatch(fetchProjectsRequest());
  }

  componentDidUpdate() {
    if (this.props.stockControllerData.createSuccess) {
      this.setState({ ...initialState, success: true });
    }

    if (this.props.stockControllerData.createdMeter) {
      this.setState({ ...initialState, createdMeter: this.props.stockControllerData.createdMeter });
    }

    if (this.props.stockControllerData.createdMeter) {
      this.props.dispatch(fetchMetersReset());
    }
  }

  handleTextChange(field, event) {
    const { value } = event.target;
    let { error } = this.state
    const newError = { ...error, [field]: false }

    const requiredMeterJobTypes = this.props.configsData.configs ?
      this.props.configsData.configs.meterRequiredJobs : [];

    if (field === 'type') {
      if (requiredMeterJobTypes.includes(value)) {
        this.setState({ [field]: value, error: newError, meterRequired: true });
      } else {
        this.setState({ [field]: value, error: newError, meterRequired: false });
      }
    } else {
      this.setState({ [field]: value, error: newError });
    }
  }


  validateJobCardForm() {
    let errorFlag = false;
    let newError = this.state.error;

      if (!this.state.meterType) {
        newError.meterType = true;
        errorFlag = true;
      }
      if (!this.state.meterPaymentType) {
        newError.meterPaymentType = true;
        errorFlag = true;
      }
    this.setState({ error: newError });
    return errorFlag;
  }

  createMeter() {
    console.log("testing payload", this.validateJobCardForm())
    if (this.validateJobCardForm()) {
      return;
    }

   

    const payload = {
      meterTyper: this.state.meterType,
      meterPaymentType: this.state.meterPaymentType,
      condition: this.state.condition,
      meterDialType: this.state.meterDialType,
      tag: this.state.tag,
      brand: this.state.brand,
      model: this.state.model,
      meterReading: parseInt(this.state.meterReading),
      meterSerialNumber: this.state.meterSerialNumber,
      meterNumber: this.state.meterNumber,
    }

    console.log("payload", payload);
    this.props.dispatch(registerMeterRequest(payload));

  }

  render() {
    const { classes } = this.props;

    const meterConditions = this.props.configsData.configs ? this.props.configsData.configs.meterConditions : [];
    const meterTypes = this.props.configsData.configs ? this.props.configsData.configs.meterType : [];
    const meterPaymentTypes = this.props.configsData.configs ? this.props.configsData.configs.meterPaymentType : [];
    const meterDialTypes = this.props.configsData.configs ? this.props.configsData.configs.meterDialType : [];

    const successButtonStyle = {
      backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    const dangerButtonStyle = {
      backgroundColor: "orange", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }
    return (
      <div>
        
<GridContainer>
          <GridItem xs={12} sm={12} md={12} >
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Meter Information</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Choose Meter Type
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          error={this.state.error.meterType}
                          value={this.state.meterType || ''}
                          onChange={this.handleTextChange.bind(this, 'meterType')}
                          inputProps={{
                            name: "meterType",
                            id: "meterType"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Type
                        </MenuItem>
                          {
                            meterTypes.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }

                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="meterPaymentType"
                        >
                          Choose Meter Payment Type
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.meterPaymentType || ''}
                          error={this.state.error.meterPaymentType}
                          onChange={this.handleTextChange.bind(this, 'meterPaymentType')}
                          inputProps={{
                            name: "meterPaymentType",
                            id: "meterPaymentType",
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Payment Type
                        </MenuItem>
                          {
                            meterPaymentTypes.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Meter Condition
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.condition || ''}
                          onChange={this.handleTextChange.bind(this, 'condition')}
                          inputProps={{
                            name: "condition",
                            id: "condition"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Condition
                        </MenuItem>

                          {
                            meterConditions.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="meterDialType"
                        >
                          Meter Dial Type
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.meterDialType || ''}
                          onChange={this.handleTextChange.bind(this, 'meterDialType')}
                          inputProps={{
                            name: "meterDialType",
                            id: "meterDialType"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Meter Dial Type
                        </MenuItem>
                          {
                            meterDialTypes.map((type, index) =>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={type}
                                key={index}
                              >
                                {formatStatus(type)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Brand"
                        id="brand"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.brand,
                          onChange: this.handleTextChange.bind(this, 'brand'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Model"
                        id="model"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.model,
                          onChange: this.handleTextChange.bind(this, 'model'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Tag"
                        id="tag"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.tag,
                          onChange: this.handleTextChange.bind(this, 'tag'),
                        }}
                      />
                    </GridItem>
                              <GridItem xs={12} sm={6} md={6}>
                                <CustomInput
                                  labelText="Meter Number"
                                  id="meterNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: this.state.meterNumber,
                                    onChange: this.handleTextChange.bind(this, 'meterNumber'),
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={6}>
                                <CustomInput
                                  labelText="Meter Serial Number"
                                  id="meterSerialNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: this.state.meterSerialNumber,
                                    onChange: this.handleTextChange.bind(this, 'meterSerialNumber'),
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={6}>
                                <CustomInput
                                  labelText="Meter Reading"
                                  id="meterReading"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: this.state.meterReading,
                                    onChange: this.handleTextChange.bind(this, 'meterReading'),
                                    type: "number"
                                  }}
                                />
                              </GridItem>



                            </GridContainer>
                  <GridContainer>
                    <br />
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div style={{ textAlign: "center" }}>

          {
            this.props.stockControllerData.loader ?
              (<CircularProgress />) :
              (
                <Button color="info" onClick={this.createMeter.bind(this)}>
                  <Add />
                  Register Meter
            </Button>
              )
          }
        </div>
        <Snackbar
          place="tc"
          color="danger"
          message={this.props.stockControllerData.error ? this.props.stockControllerData.error.message : 'An unexpected error occured'}
          open={!!this.props.stockControllerData.error}
          closeNotification={() => this.props.dispatch(fetchMetersReset())}
          close
        />
        <Snackbar
          place="tc"
          color="success"
          message={'Successfully registered the meter'}
          open={this.state.success}
          closeNotification={() => this.setState({ success: false })}
          close
        />
        {this.state.createdMeter ? <SweetAlert
          success
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Meter registered Successfully!"
          onConfirm={() => this.props.history.replace(`/admin/meters`)}
          
          onCancel={() => this.setState({createdMeter:null})}
          confirmBtnStyle={successButtonStyle}
          cancelBtnStyle={dangerButtonStyle}
          confirmBtnText="View Meters!"
          cancelBtnText="Close"
        >
        </SweetAlert>: ''}
      </div>
    );
  }
}

export default withStyles(extendedFormsStyle)(
  connect(state => ({
    configsData: state.appConfigState,
    stockControllerData: state.jobCardState,
    stockControllerData: state.stockControllerState,

  }))(CreateMeter)
);
